import { heroImage } from '@/mocks/yy';

export default function Hero() {
  return (
    <section id="home" className="relative flex items-center justify-center w-full h-[560px] md:h-[620px] overflow-hidden">
      <div className="absolute inset-0">
        <img
          src={heroImage}
          alt="歪歪官方网站入口导航背景图"
          className="w-full h-full object-cover object-center"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/55 via-black/35 to-black/60"></div>

      <div className="relative z-10 w-full max-w-4xl mx-auto px-4 md:px-6 text-center py-16">
        <span className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-accent-500 text-foreground-950 text-xs md:text-sm font-medium">
          <i className="ri-flashlight-line" aria-hidden="true"></i>
          歪歪官方网站一键直达入口
        </span>

        <h1 className="mt-6 text-3xl md:text-5xl lg:text-6xl text-background-50 font-heading leading-tight">
          歪歪官方网站 · 首页入口
        </h1>

        <p className="mt-5 text-background-50/95 text-base md:text-lg leading-relaxed max-w-2xl mx-auto">
          为你整理歪歪官方网站入口、地址、首页、网址与登录方式，收藏本页即可随时直达平台首页，一步进入登录流程，省时省力。
        </p>

        <div className="mt-8 flex flex-col sm:flex-row items-center justify-center gap-3">
          <a
            href="https://www.yy.com"
            target="_blank"
            rel="nofollow noopener"
            className="inline-flex items-center gap-2 px-6 py-3 rounded-md bg-primary-500 text-background-50 text-base whitespace-nowrap hover:bg-primary-600 transition-colors"
          >
            <i className="ri-external-link-line text-lg" aria-hidden="true"></i>
            进入歪歪官方网站首页
          </a>
          <a
            href="#guide"
            className="inline-flex items-center gap-2 px-6 py-3 rounded-md bg-background-50 text-foreground-950 text-base whitespace-nowrap hover:bg-background-100 transition-colors"
          >
            <i className="ri-guide-line text-lg" aria-hidden="true"></i>
            查看登录指南
          </a>
        </div>

        <div className="mt-10 flex flex-wrap items-center justify-center gap-x-6 gap-y-2 text-background-50/85 text-xs md:text-sm">
          <span className="inline-flex items-center gap-1.5"><i className="ri-checkbox-circle-line text-accent-300" aria-hidden="true"></i>官网直达</span>
          <span className="inline-flex items-center gap-1.5"><i className="ri-checkbox-circle-line text-accent-300" aria-hidden="true"></i>登录指引</span>
          <span className="inline-flex items-center gap-1.5"><i className="ri-checkbox-circle-line text-accent-300" aria-hidden="true"></i>多端适配</span>
          <span className="inline-flex items-center gap-1.5"><i className="ri-checkbox-circle-line text-accent-300" aria-hidden="true"></i>收藏即达</span>
        </div>
      </div>
    </section>
  );
}